import React from 'react';
import PropTypes from 'prop-types';
import getChartActionItems, { chartActionPropTypes, chartActionDefaultProps } from './chartActionItems';
import Button from '../Button';
import Tooltip from '../Tooltip';
import { captureAnalytics } from '../../actions/preload';

const ChartActionButtons = (props) => {
  if (props.hide) return null;

  return getChartActionItems(props).map((action) => (action.visible ? (
    <Tooltip key={action.key} title={(action.disabled && props.disabledExplanation) || action.description}>
      <span className="record-action-bar__chart-action">
        <Button
          type="tertiary"
          size="small"
          label={action.label}
          leftIcon={<action.Icon size={16} weight={action.iconWeight} />}
          disabled={action.disabled}
          data-tutorial={action.tutorial}
          onClick={(event) => {
            captureAnalytics('record_viewer_chart_action_selected', { action: action.key });
            action.handler(event);
          }}
        />
      </span>
    </Tooltip>
  ) : null));
};

ChartActionButtons.propTypes = { ...chartActionPropTypes, hide: PropTypes.bool };
ChartActionButtons.defaultProps = { ...chartActionDefaultProps, hide: false };

export default ChartActionButtons;
